export const FONT_FAMILY_DEFAULT = "Nunito";

export const TEXT_INPUT_FONTSIZE = 25;

export const TEXT_COLOR_ERROR = "#ef877f";
